const ComprehensiveLitigationIcon = () => {
  return (
    <>
      <svg
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0431 0C13.9995 0 15.5848 1.58525 15.5848 3.54167C15.5848 5.49808 13.9995 7.08333 12.0431 7.08333C10.0867 7.08333 8.50142 5.49808 8.50142 3.54167C8.50142 1.58525 10.0867 0 12.0431 0ZM17.6304 11.8008C17.8288 11.2327 17.6474 10.5995 17.1757 10.2255C15.7803 9.11342 13.957 8.5 12.0431 8.5C10.1292 8.5 8.30592 9.11342 6.9105 10.2255C6.43875 10.6009 6.25742 11.2327 6.45575 11.8008C6.6555 12.3689 7.19242 12.75 7.79308 12.75H16.2931C16.8952 12.75 17.4321 12.3689 17.6304 11.8008ZM32.7944 12.2981C32.0648 11.6337 31.1142 11.2894 30.1339 11.3376C29.1465 11.3829 28.237 11.8108 27.5924 12.5205L22.576 17.8146C22.6213 18.1121 22.6681 18.4096 22.6681 18.7184C22.6681 21.6693 20.4652 24.2094 17.544 24.6259L11.5203 25.4702C10.7454 25.5807 10.0286 25.0424 9.91808 24.2689C9.80758 23.494 10.3459 22.7772 11.1194 22.6667L17.0156 21.8407C18.3416 21.6509 19.4919 20.6989 19.7639 19.3871C20.1833 17.3683 18.6448 15.5833 16.6982 15.5833H5.66667C2.53725 15.5833 0 18.1206 0 21.25V28.3333C0 31.4627 2.53725 34 5.66667 34H11.7045C15.6782 34 19.4678 32.3312 22.151 29.4015L33.0622 17.4888C34.4052 15.9843 34.2833 13.6552 32.7944 12.2981Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default ComprehensiveLitigationIcon;
